import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/img/aajp-logo.jpg")